/* eslint-disable react/jsx-no-bind */

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { submit } from 'redux-form';
import { SnapcodeViewModel } from 'stageclip-common';

import { createModalCloseAction } from '../../../actions/modalActions';
import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { SimpleModalId } from '../../../constants/modalId';
import { baseMapDispatchToProps, ComponentBase, BaseDispatchProps, BaseStateProps } from '../../componentBase';
import AppForm from '../../form/appForm';
import AppModal from '../../modal/appModal';
import TabulatedForm from '../../modal/tabulatedForm';
import { mapBaseEventStateToProps } from '../baseEventForm';

import styles from './addParticipantForm.module.scss';
import BaseParticipantFormFields from './baseParticipantFormFields';
import UnknownParticipantFormFields from './unknownParticipantFormFields';

interface AddParticipantFormOwnProps {
  eventId: string;
  isSurveyTurnedOn: boolean;
  isSnapchatTurnedOn: boolean;
  snapcodes: SnapcodeViewModel[];
}

interface AddParticipantFormDispatchProps extends BaseDispatchProps {
  submitForm: (formId: string) => void;
  closeModal: () => void;
}

class AddParticipantForm extends ComponentBase<
  AddParticipantFormOwnProps,
  BaseStateProps,
  AddParticipantFormDispatchProps
> {
  private formId: string;

  constructor(props: any) {
    super(props);
    this.formId = FormId.AddParticipants;
  }

  protected loggedInRender() {
    const boundSubmit = this.submitForm.bind(this);
    const boundHandleFormChange = this.handleFormChange.bind(this);

    return (
      <AppModal
        id={SimpleModalId.AddParticipant}
        buttonIcon={faPlus}
        invertedButtonColours
        submitAction={boundSubmit}
        title="Add participant"
        className={styles.addParticipantForm}
      >
        <TabulatedForm handleSelectedFormChange={boundHandleFormChange}>
          <AppForm
            title="Add participant"
            form={FormId.AddParticipants}
            submitActionType={DataRequestActionTypes.AddParticipantRequested}
            reduxData={{ eventId: this.props.eventId }}
            hideButtons
            onSuccess={this.props.closeModal}
          >
            <BaseParticipantFormFields
              isSurveyTurnedOn={this.props.isSurveyTurnedOn}
              isSnapchatTurnedOn={this.props.isSnapchatTurnedOn}
              snapcodes={this.props.snapcodes}
            />
          </AppForm>
          <AppForm
            title="Add unknown participant"
            form={FormId.AddUnknownParticipant}
            submitActionType={DataRequestActionTypes.AddUnknownParticipantRequested}
            reduxData={{ eventId: this.props.eventId }}
            hideButtons
            onSuccess={this.props.closeModal}
          >
            <UnknownParticipantFormFields eventId={this.props.eventId} />
          </AppForm>
        </TabulatedForm>
      </AppModal>
    );
  }

  private handleFormChange(formId: string) {
    this.formId = formId;
  }

  private submitForm() {
    this.props.submitForm(this.formId);
  }
}

function mapDispatchToProps(dispatch: Dispatch): AddParticipantFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    closeModal: () => dispatch(createModalCloseAction(SimpleModalId.AddParticipant)),
    submitForm: (formId: string) => dispatch(submit(formId)),
  };
}

export default connect(mapBaseEventStateToProps, mapDispatchToProps)(AddParticipantForm);
